import React, { useState } from "react";
import { TopBar } from "@shopify/polaris";
import { ExitIcon, LayoutColumns3Icon, SettingsIcon, StoreIcon } from "@shopify/polaris-icons";
import { useNavigate } from "react-router-dom";

import BranchSwitcherModal from "../Dashboard/BranchSwitcherModal";
import { UserAuth } from "../../context/AuthContext";
import { useBranch } from "../../context/BranchContext";

// Slim top bar for the Polaris design: user menu (branch, settings, layout,
// sign out) and the hamburger that opens the navigation on phones.
function PolarisTopBar({ onNavigationToggle }) {
  const { session, setNavLayout, signOutUser } = UserAuth();
  const { branch, isLargoPlazo } = useBranch();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [branchOpen, setBranchOpen] = useState(false);

  const user = session?.user;
  const name = user?.user_metadata?.name || user?.email || "";
  const initials = name.replace(/@.*/, "").split(/[\s._-]+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");
  const branchLabel = branch ? `${branch.name} · ${isLargoPlazo ? "LP" : "CP"}` : undefined;

  const userMenu = (
    <TopBar.UserMenu
      name={name}
      detail={branchLabel}
      initials={initials}
      open={menuOpen}
      onToggle={() => setMenuOpen((o) => !o)}
      actions={[
        {
          items: [
            { content: "Cambiar sucursal", icon: StoreIcon, onAction: () => setBranchOpen(true) },
            { content: "Personalizar menú", icon: SettingsIcon, onAction: () => navigate("/settings/menu") },
            { content: "Diseño clásico", icon: LayoutColumns3Icon, onAction: () => setNavLayout("classic") },
          ],
        },
        { items: [{ content: "Salir", icon: ExitIcon, onAction: () => signOutUser() }] },
      ]}
    />
  );

  return (
    <>
      <TopBar showNavigationToggle userMenu={userMenu} onNavigationToggle={onNavigationToggle} />
      <BranchSwitcherModal open={branchOpen} onClose={() => setBranchOpen(false)} />
    </>
  );
}

export default PolarisTopBar;
